import * as React from "react";
import PlainDate from "@testout/testout-commerce/models/PlainDate";

interface IMonthProps {
    className?: string;
    placeholder?: string;
    disabled?: boolean;
    value?: Date;
    text: string;
    onChange?: (value?: Date) => void;
    onTextChange?: (value: string) => void;
}

interface IMonthState {
    caret: number;
}

export default class MonthCtl extends React.PureComponent<IMonthProps, IMonthState> {
    constructor(props: IMonthProps) {
        super(props);
        this.state = { caret: 0 };
    }

    _inputRef = React.createRef<HTMLInputElement>();

    //static getDerivedStateFromProps(props: IMonthProps, state: IMonthState) {
    //    return { value: props.value ? PlainDate.format(props.value, "MM/yy") : "" };
    //}

    onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        //console.log(`onChange(value = ${e.currentTarget.value}, props.text = ${this.props.text}, state.value = ${this.props.value})`)

        // Get the changed value trimmed at caret
        let caret = e.currentTarget.selectionStart ?? 0;
        let value = e.currentTarget.value.substring(0, caret);

        if (/^00$/.test(value)) 
            value = "0";
        else if (/^0[1-9]$/.test(value))
            value = value.substr(0, 2) + "/";
        else if (/^0\/$/.test(value)) 
            value = "0";
        else if (/^1[0-2]$/.test(value)) 
            value = value.substr(0, 2) + "/";
        else if (/^1[3-9]$/.test(value)) 
            value = "1";
        else if (/^1\/$/.test(value)) 
            value = "01/";
        else if (/^[2-9]$/.test(value)) 
            value = "0" + value.substr(0, 1) + "/";

        caret = value.length;
        if (value.length === 0 || value.length === 5)
            this.props.onChange?.(value.length === 0 ? undefined : PlainDate.parse("20" + value.substr(3, 2) + "-" + value.substr(0, 2)));

        if (this.state.caret === caret && this.props.text === value)
            this.forceUpdate(); // We force the update so the caret position gets set
        else {
            this.props.onTextChange?.(value);
            this.setState({ caret: caret });
        }
    }

    componentDidUpdate() {
        const inp: HTMLInputElement|null = this._inputRef.current;
        if (inp)
            inp.setSelectionRange(this.state.caret, this.state.caret);
    }

    render() {
        return <input ref={this._inputRef} className={this.props.className}
                      type="text"
                      value={this.props.text}
                      placeholder={this.props.placeholder}
                      onChange={this.onChange}
                      disabled={this.props.disabled}/>;
    }
}